import s from './style.css';
import cn from 'classnames';

export default ({ size = 'large', children, className }) => (
	<div
		className={cn(s.container, {
			[s[size]]: true,
			[className]: className
		})}
	>
		{children}
	</div>
);



// WEBPACK FOOTER //
// ./elements/container/index.js